var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"molecule-select"},_vm._l((_vm.items),function(item){return _c('atom-link',{key:item.route,staticClass:"item",attrs:{"exact":"","replace":"","active-class":"selected","to":item.route,"text":item.label}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }